import {apiAxios} from "@/service/APIClient";
import StoreItemDTO from "@/models/StoreItemDTO";

export const store = {
    items: async (): Promise<StoreItemDTO[]> => {
        let resp = await apiAxios({
            url: `/store/items`,
            method: 'GET',
        })

        return resp.data as StoreItemDTO[]
    },
}